import { render } from "./NotificationLogs.vue?vue&type=template&id=8ff76ffc"
import script from "./NotificationLogs.vue?vue&type=script&lang=js"
export * from "./NotificationLogs.vue?vue&type=script&lang=js"

import "./NotificationLogs.vue?vue&type=style&index=0&id=8ff76ffc&lang=sass"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__